import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
	GetCmsObjectdetail,
	UpdateCmsObject,
	GetCmsObjectTypes,
	CreateCmsObject,
} from '../CMS_api';
import Styles from './CMSDetail.module.scss';
import Base from '../../../Base/Base';
import DetailsSection from './CMSDetail/DetailsSection';
import FooterControls from './CMSDetail/FooterControls';
import { useHistory } from 'react-router-dom';
import { ValidateCMSObject } from '../../CMS_Utils';
const CMSDetail = props => {
	const [cmsObject, setCmsObject] = useState({});
	const [updateObject, setUpdateObject] = useState({});
	const [rLoading, setrLoading] = useState(false);
	const [editable, setEditable] = useState(false);
	const [wasEdited, setWasEdited] = useState(false);
	const [createNew, setCreateNew] = useState(false);
	const [types, setTypes] = useState([]);
	const [selectedType, setSelectedType] = useState({});
	let { cmsObjectID } = useParams();
	const [statusTypes, setStatusTypes] = useState({});
	const [validationErrors, setValidationErrors] = useState([]);

	const history = useHistory();

	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth();
	const currentDay = new Date().getDate();

	const stateObj = {
		updateObject,
		setUpdateObject,
		rLoading,
		editable,
		setEditable,
		wasEdited,
		setWasEdited,
		cmsObjectID,
		handleSave,
		currentUser: props.currentUser,
		new: props.new,
		resetForm,
		types,
		selectedType,
		setSelectedType,
		statusTypes,
		validationErrors,
		displayValidationError,
	};

	useEffect(() => {
		//load selected cmsObject
		GetCmsObjectTypes().then(response => {
			setTypes(response.data.ObjectTypes);
			setStatusTypes(response.data.StatusTypes);
			setSelectedType(response.data.ObjectTypes[0]);
		});
		setCreateNew(props.new);

		if (!props.new) {
			setrLoading(true);
			GetCmsObjectdetail(cmsObjectID)
				.then(response => {
					setCmsObject(response.data);
					setUpdateObject({ ...response.data });
				})

				.then(result => {
					setrLoading(false);
				});
		}
		//reset window beforeunload behavior once component dismounts
		return function () {
			window.onbeforeunload = () => {
				return null;
			};
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cmsObjectID]);

	useEffect(() => {
		setUpdateObject({ ...cmsObject });
	}, [cmsObject]);

	useEffect(() => {
		//validate object on change
		if (Object.keys(updateObject).length > 1) {
			setValidationErrors(ValidateCMSObject(updateObject));
		}
	}, [updateObject]);

	useEffect(() => {
		if (selectedType && selectedType.FieldDefinitions && props.new) {
			//initialize update Object with required values
			setUpdateObject({
				...updateObject,
				ObjectType: selectedType,
				ObjecTypeID: selectedType.ID,
				Fields: selectedType.FieldDefinitions.map(fieldDef => {
					return {
						Value: '',
						CMSFieldDefinitionID: fieldDef.ID,
						FieldDefinition: fieldDef,
					};
				}),
				StartDate: new Date(),
				EndDate: new Date(currentYear + 1, currentMonth, currentDay),

				StatusTypes: statusTypes,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedType, types]);

	function handleSave(e) {
		if (props.new) {
			CreateCmsObject(updateObject).then(response => {
				if (response.data.ID) {
					setCmsObject();
				}

				setCmsObject({ ...response.data });
				setUpdateObject({ ...response.data });
				if (response.data.ID) {
					history.push(`/CMSManagement/${response.data.ID}`, {
						updateObject: { ...response.data },
					});
				}
			});
		} else {
			UpdateCmsObject(updateObject).then(response =>
				setCmsObject(response.data)
			);
		}

		//reset state variables
		setEditable(false);
		setWasEdited(false);
		function ignoreConfirmation() {
			return null;
		}
		window.onbeforeunload = ignoreConfirmation;
	}

	function resetForm() {
		setUpdateObject({ ...cmsObject });
	}

	function displayValidationError(propertyName) {
		let error = validationErrors.find(
			error => error.field === propertyName
		);
		if (error) {
			return (
				<>
					<span className={Styles.validationError}>
						{error.message}
					</span>
				</>
			);
		} else {
			///reserve space for error message
			return <span className={Styles.validationError}>&nbsp;</span>;
		}
	}

	return (
		<Base loading={rLoading} title={'CMS Object Details'} helpLink={''}>
			{(updateObject && updateObject.ObjectType && cmsObjectID) ||
			createNew ? (
				<div className={Styles.DetailsSection}>
					<DetailsSection {...stateObj} Styles={Styles} />

					<FooterControls {...stateObj} Styles={Styles} />
				</div>
			) : (
				<div>No valid object found</div>
			)}
		</Base>
	);
};

export default CMSDetail;
